// src/Contact.js

import Gif from "./Gif";

const Contact = () => (
    <div>
        <h2>Get in touch</h2>
            <p>email: Elliot[dot]verified[at]gmail[dot]com</p>
            <p>twitter: @WaxmanElliot</p>
            <Gif/>
    </div>
  );
  
  export default Contact;
  